<template>
    <div class="d-flex flex-row flex-wrap mx-2" v-if="video">
        <!--videos contenues dans le parcours de la video sélectionnée -->
        <div class="p-2 col-xl-8 col-lg-8 col-md-12 col-sm-12">
          <video-item :video="video" :nextVideo="nextVideo"></video-item>
          <h3 v-if="video.courses.length > 0" class="pt-8 mb-0">
            {{ $tc("video.courses", video.courses.length) }}
          </h3>
          <div v-for="course in video.courses" :key="course.id">
            <CourseItem :course="course"></CourseItem>
          </div>
        </div>

        <!--video sélectionnée + liste videos correspondant au mot clé -->
        <div class="p-2 col-xl-4 col-lg-4 col-md-12 col-sm-12">
          <div class="d-flex flex-column align-items-start">
            <div class="mb-auto" style="width: 100%">
              <h3>{{ $t("video.otherVideos") }}</h3>
              <VideosFromKeywords
                :video="video"
                @nextVideoDetected="getNextVideo"
              />
              <v-divider></v-divider>
              <h3 class="pt-7">{{ $t("video.keyword") }}</h3>
              <v-card-text class="pl-0">
                <div v-if="video.keywords.length > 0">
                  <b-badge
                    class="mr-1 mb-1"
                    v-for="keyword in video.keywords.filter(
                      (k) => k.isVisible && k.lang === 'FR'
                    )"
                    :key="keyword.id"
                  >
                    {{ keyword.name }}
                  </b-badge>
                </div>
                <div v-else>
                  <b-badge>{{ $t("video.others.tag") }}</b-badge>
                </div>
              </v-card-text>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Api from "@/core/services/api.service";
import VideoItem from "@/components/video/videoItem";
import CourseItem from "@/components/course/courseItem";
import VideosFromKeywords from "@/components/video/videosFromKeywords";

export default {
  name: "contentVideo",
  components: { VideoItem, CourseItem, VideosFromKeywords },
  data: () => ({
    video: null,
    nextVideo: null,
  }),
  methods: {
    getNextVideo(nxt) {
      this.nextVideo = nxt;
    },
  },
  mounted() {
    const videoId = this.$route.params.id;

    Api.get("videos", videoId).then((video) => {
      this.video = video.data;
      this.$store.dispatch(SET_BREADCRUMB, [
        {
          title: this.$i18n.t("sidebar.videosMenu"),
          route: "bibliothequeVideos",
        },
        { title: this.video.title },
      ]);
    });
  },
};
</script>
